import React, { useState, useRef, useEffect, useMemo } from "react";
import { ScrollContainer } from "../_components";
import { ChronosDate } from "../_helpers";
import { useTime } from "../_contexts";

import { TimelineSlot, TimelineScroller } from "./";
import { UTDBar } from "./UTD";
import { TimelineNavigation } from "./TimelineNavigation";
import { Scrollbars } from "react-custom-scrollbars";
// import ReactTooltip from "react-tooltip";

export function TimelinesContainer({
  chronicle,
  timelines,
  parentRef,
  showUTD,
  containerRef,
  world,
}) {
  console.log("Timeline Container Render");
  const [timelineSlots, setTimelineSlots] = useState([]);
  const {
    updateScrollPosition,
    // unitsDisplay,
    granularity,
    currentDate,
    calendar,
    setCurrentDate,
    scrollPosition,
  } = useTime();
  console.log("Rendering Date", currentDate);
  const { startDate, defaultUnit, unitDisplayCount } = chronicle;
  const movement = useRef(0);
  const scrollContainer = useRef();
  const lastDate = useRef();

  const displayCount = unitDisplayCount;
  const containerWidth = displayCount * 15;

  const handleNavigationChange = (date, newPosition) => {
    console.log("New Date", date, newPosition);
    setCurrentDate(date);
    if (newPosition !== undefined && containerRef && containerRef.current) {
      console.log("Setting New Position from Navigation");
      updateScrollPosition(newPosition);
      containerRef.current.setPosition(newPosition);
    }
  };

  //Handler for onscroll events
  const handleScroll = (ev) => {
    // console.log('Scrolling', ev);
    updateScrollPosition(null);
  };

  const handleScrollEnd = (ev) => {
    // if (currentDate === lastDate.current) {
    //   console.log('Should we actually be updating??');
    // }
    updateScrollPosition(ev.scrollLeft);
  };

  useEffect(() => {
    console.log("Calculating Timeline Slots!", currentDate);

    const newtimelineSlots = timelines
      .filter((t) => t.active)
      .sort((a, b) => {
        return a.order > b.order ? 1 : -1;
      })
      .map((t) => {
        // if (!t.active) return undefined;
        // return useMemo(() => {
        return (
          <TimelineSlot
            timeline={t}
            key={t._id}
            chronicle={chronicle}
            currentDate={currentDate}
            timelineCalendar={calendar}
            granularity={granularity}
            units={chronicle.unitDisplayCount}
            containerRef={containerRef}
          />
        );
        // }, [timelines, chronicle, currentDate, calendar, granularity]);
      });

    setTimelineSlots(newtimelineSlots);
    lastDate.current = currentDate;
  }, [timelines, granularity, currentDate, calendar]);

  //Set the initial position of the TimelineContainer based on Chronicle settings
  useEffect(() => {
    if (startDate) {
      console.log("Recalculating startdate or calendar");
      //Get the offset position, based on Chronicle's starting date
      const initialDate = new ChronosDate(startDate, {
        calendar,
      });
      const segment = initialDate.getTimelineSegment(defaultUnit, {
        unitCountDisplay: unitDisplayCount,
      });
      const position = initialDate.getPositionFromStart(
        segment.start,
        defaultUnit
      );

      //Update the Scroll Position tracker
      updateScrollPosition(position);

      //Force-set the initial focus for the Scroll Container (only applies on re-render)
      if (movement.current) {
        // console.log('MovementRef is set.');
        movement.current = position;
      }

      //Set the ScrollContainer's position
      if (containerRef.current) {
        // console.log('ScrollContainerRef is set');
        containerRef.current.setPosition(position);
      }
    }
  }, [startDate, calendar]);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.setPosition(scrollPosition);
    }
  }, [scrollPosition]);
  // ReactTooltip.rebuild();
  return (
    <React.Fragment>
      <ScrollContainer
        className="chronos-timelines-container-component"
        horizontal
        ref={containerRef}
        innerRef={scrollContainer}
        component="div"
        // component={Scrollbars}
        onScroll={handleScroll}
        onScrollEnd={handleScrollEnd}
        activationDistance={10}
        startFocused={{ x: movement.current || 0 }}
        parentElement={parentRef.current}
        innerWidth={containerWidth}
        style={{
          width: window.innerWidth,
          height: timelineSlots && timelineSlots.length <= 1 ? 197 : 333,
        }}
      >
        <div
          className="chronos-timeline-wrapper"
          style={{ width: containerWidth, boxSizing: "content-box" }}
        >
          <TimelineNavigation
            direction="prev"
            date={currentDate}
            step={granularity}
            calendar={calendar}
            segmentSize={displayCount}
            update={handleNavigationChange}
          />
          <Scrollbars
            className="chronos-timeline-slots"
            style={{
              width: containerWidth,
              height: timelineSlots && timelineSlots.length <= 1 ? 140 : 280,
            }}
            hideTracksWhenNotNeeded={true}
            renderTrackHorizontal={({ props, style }) => (
              <div {...props} style={{ ...style, background: "transparent" }} />
            )}
            renderView={({ style }) => (
              <div
                className="chronos-timeline-slots-list"
                style={{ ...style, marginBottom: 0, overflow: "auto" }}
              ></div>
            )}
          >
            {timelineSlots}
          </Scrollbars>
          {timelineSlots && timelineSlots.length >= 3 && (
            <TimelineScroller
              containerRef={containerRef}
              slots={timelineSlots}
            />
          )}
          <TimelineNavigation
            direction="next"
            date={currentDate}
            step={granularity}
            calendar={calendar}
            segmentSize={displayCount}
            update={handleNavigationChange}
          />
          {showUTD && world && world.worldTime && (
            <UTDBar
              displayWidth={containerWidth}
              granularity={granularity}
              calendar={calendar}
              currentDate={currentDate}
              world={world}
            />
          )}
        </div>
      </ScrollContainer>
    </React.Fragment>
  );
}
